// Machine-draft UI-only Journey discovery strings; no clinical directions.
// Keep these separate from the legally and clinically governed Journey text.
const KEYS = Object.freeze([
  'configuredTrustTitle','configuredTrustBody','configuredTrustFallback','yourHospital'
]);
const DRAFTS = Object.freeze({
  "ar": [
    "رحلات رعايتك في {{hospital}}",
    "اختر رحلة للتعرّف على ما قد يحدث، ومن قد تقابل، والمعلومات المعتمدة من مستشفاك.",
    "مستشفاك",
    "مستشفاك"
  ],
  "bn": [
    "{{hospital}}-এ আপনার চিকিৎসাসেবার যাত্রাগুলো",
    "কী হতে পারে, কাদের সঙ্গে আপনার দেখা হতে পারে এবং আপনার হাসপাতালের অনুমোদিত তথ্য জানতে একটি যাত্রা বেছে নিন।",
    "আপনার হাসপাতাল",
    "আপনার হাসপাতাল"
  ],
  "es": [
    "Sus recorridos asistenciales en {{hospital}}",
    "Elija un recorrido para saber qué puede ocurrir, a quién podría conocer y consultar información aprobada por su hospital.",
    "su hospital",
    "Su hospital"
  ],
  "fa": [
    "مسیرهای مراقبت شما در {{hospital}}",
    "یک مسیر را انتخاب کنید تا بدانید چه اتفاقاتی ممکن است بیفتد، چه کسانی را ممکن است ببینید و اطلاعات تأییدشدهٔ بیمارستان خود را بخوانید.",
    "بیمارستان شما",
    "بیمارستان شما"
  ],
  "fr": [
    "Vos parcours de soins à {{hospital}}",
    "Choisissez un parcours pour découvrir ce qui pourrait se passer, les professionnels que vous pourriez rencontrer et les informations approuvées par votre hôpital.",
    "votre hôpital",
    "Votre hôpital"
  ],
  "gu": [
    "{{hospital}} ખાતે તમારી સંભાળની યાત્રાઓ",
    "શું થઈ શકે છે, તમને કોણ મળી શકે છે અને તમારી હોસ્પિટલની મંજૂર માહિતી જાણવા માટે એક યાત્રા પસંદ કરો.",
    "તમારી હોસ્પિટલ",
    "તમારી હોસ્પિટલ"
  ],
  "it": [
    "I tuoi percorsi di cura presso {{hospital}}",
    "Scegli un percorso per scoprire cosa potrebbe accadere, quali professionisti potresti incontrare e le informazioni approvate dal tuo ospedale.",
    "il tuo ospedale",
    "Il tuo ospedale"
  ],
  "pa": [
    "{{hospital}} ਵਿੱਚ ਤੁਹਾਡੀ ਦੇਖਭਾਲ ਦੇ ਸਫ਼ਰ",
    "ਕੀ ਹੋ ਸਕਦਾ ਹੈ, ਤੁਸੀਂ ਕਿਸ ਨੂੰ ਮਿਲ ਸਕਦੇ ਹੋ ਅਤੇ ਆਪਣੇ ਹਸਪਤਾਲ ਵੱਲੋਂ ਮਨਜ਼ੂਰ ਕੀਤੀ ਜਾਣਕਾਰੀ ਦੇਖਣ ਲਈ ਇੱਕ ਸਫ਼ਰ ਚੁਣੋ।",
    "ਤੁਹਾਡਾ ਹਸਪਤਾਲ",
    "ਤੁਹਾਡਾ ਹਸਪਤਾਲ"
  ],
  "pl": [
    "Twoje ścieżki opieki w {{hospital}}",
    "Wybierz ścieżkę, aby dowiedzieć się, co może się wydarzyć, kogo możesz spotkać, i poznać informacje zatwierdzone przez Twój szpital.",
    "Twój szpital",
    "Twój szpital"
  ],
  "pt": [
    "Os seus percursos de cuidados em {{hospital}}",
    "Escolha um percurso para saber o que pode acontecer, quem poderá encontrar e consultar informações aprovadas pelo seu hospital.",
    "o seu hospital",
    "O seu hospital"
  ],
  "ro": [
    "Parcursurile dumneavoastră de îngrijire la {{hospital}}",
    "Alegeți un parcurs pentru a afla ce se poate întâmpla, pe cine ați putea întâlni și informațiile aprobate de spitalul dumneavoastră.",
    "spitalul dumneavoastră",
    "Spitalul dumneavoastră"
  ],
  "so": [
    "Safarrada daryeelkaaga ee {{hospital}}",
    "Dooro safar si aad u ogaato waxa dhici kara, dadka aad la kulmi karto iyo macluumaadka uu isbitaalkaagu ansixiyay.",
    "isbitaalkaaga",
    "Isbitaalkaaga"
  ],
  "tl": [
    "Mga gabay sa pangangalaga mo sa {{hospital}}",
    "Pumili ng gabay upang malaman kung ano ang maaaring mangyari, kung sinu-sino ang maaari mong makilala, at ang impormasyong inaprubahan ng iyong ospital.",
    "iyong ospital",
    "Iyong ospital"
  ],
  "tr": [
    "{{hospital}} hastanesindeki bakım süreçleriniz",
    "Neler olabileceğini, kimlerle karşılaşabileceğinizi ve hastanenizce onaylanmış bilgileri görmek için bir süreç seçin.",
    "hastaneniz",
    "Hastaneniz"
  ],
  "ur": [
    "{{hospital}} میں آپ کی نگہداشت کے مراحل",
    "یہ جاننے کے لیے ایک مرحلہ منتخب کریں کہ کیا ہو سکتا ہے، آپ کن لوگوں سے مل سکتے ہیں اور آپ کے ہسپتال کی منظورشدہ معلومات کیا ہیں۔",
    "آپ کا ہسپتال",
    "آپ کا ہسپتال"
  ],
  "zh": [
    "您在{{hospital}}的就医流程",
    "选择一项就医流程，了解可能发生的事情、您可能遇到的医护人员，以及医院批准的信息。",
    "您的医院",
    "您的医院"
  ]
});
const lang = input => String(input || '').toLowerCase().split('-')[0];
export const JOURNEY_DISCOVERY_LOCALES = Object.freeze(Object.keys(DRAFTS).sort());
export const JOURNEY_DISCOVERY_KEYS = KEYS;
export function journeyDiscoveryDraftFor(language, path) {
  const index = KEYS.indexOf(path);
  return index < 0 ? undefined : DRAFTS[lang(language)]?.[index];
}
export function installJourneyDiscoveryDrafts(i18n, language, namespace) {
  if (namespace !== 'journeyInfo') return;
  const code = lang(language);
  const values = DRAFTS[code];
  if (!values) return;
  KEYS.forEach((path,index)=>{
    const existing = i18n.getResource(code, namespace, path);
    if (typeof existing !== 'string' || !existing.trim())
      i18n.addResource(code, namespace, path, values[index]);
  });
}
